export let serviceNames = [
    'web-app-development-services',
    'metaverse-development',
    'NFT-marketplaces-platforms',
    'mob-app-development-servies',
    'webGL-development',
    'software-development',
    'artificial-intelligence',
    'ui-ux-design',
    'robotics',
    'automation-testing',
    'quality-assurance',
    'blockchain-development',
    'ebook-cover-making',
    'e-book-writting-both-fiction-and-non-fiction',
    'content-writing'
]